import { render, staticRenderFns } from "./PosAddProductService.vue?vue&type=template&id=7b0d79ee&scoped=true&"
import script from "./PosAddProductService.vue?vue&type=script&lang=js&"
export * from "./PosAddProductService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0d79ee",
  null
  
)

export default component.exports